import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { EmpresaDto, EmpresaSchema } from "./Empresa.Dto";
import {
  EmpresaAtualizar,
  EmpresaBuscarPorUsuario,
  EmpresaIncluir,
} from "src/services/Entidade.Service";
import {
  filtrarRotasPorRotaAtual,
  FormatarCEP,
  FormatarCNPJ,
  MapearErrosServidorCampo,
  SoNumeros,
} from "src/hook/Functions";
import { useLocation, useNavigate } from "react-router-dom";
import { BuscarCep } from "src/services/ViaCEP";
import { MenuItemDto } from "../../Menu/MenuItem.Dto";
import { showToast } from "src/componentes";

const EmpresaCode = () => {
  const [loading, setLoading] = useState(false);
  const [incluir, setIncluir] = useState(false);
  const [menuItens, setMenuItens] = useState<MenuItemDto[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue,
    getValues,
  } = useForm<EmpresaDto>({
    resolver: yupResolver(EmpresaSchema),
    defaultValues: undefined,
  });
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setLoading(true);
      await EmpresaBuscarPorUsuario()
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data as EmpresaDto;
            data.documento = FormatarCNPJ(data.documento);
            data.cep = FormatarCEP(data.cep);
            reset(data);
            setIncluir(false);
            const subRotas = filtrarRotasPorRotaAtual(location.pathname) || [];
            if (!subRotas.some((r) => r.rota?.toLowerCase().includes("logo"))) {
              subRotas.push({
                nome: "Logo",
                rota: "/entidade/empresa/logo",
              } as MenuItemDto);
            }
            setMenuItens(subRotas);
          } else {
            setIncluir(true);
          }
        })
        .catch((error) => {
          console.log(error);
          showToast({
            message: "Ocorreu erro ao buscar empresa",
            title: "Erro",
            variant: "Danger",
          });
          return undefined;
        })
        .finally(() => {
          setLoading(false);
        });
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  const buscarCep = (cep: string) => {
    if (SoNumeros(cep).length === 8) {
      BuscarCep(cep)
        .then((response: any) => {
          if (response && !response.erro) {
            const current = getValues();

            if (
              (!current.bairro || current.bairro.trim() === "") &&
              response.bairro
            ) {
              setValue("bairro", response.bairro);
            }
            if (
              (!current.endereco || current.endereco.trim() === "") &&
              response.logradouro
            ) {
              setValue("endereco", response.logradouro);
            }
            if (
              (!current.nomeMunicipio || current.nomeMunicipio.trim() === "") &&
              response.localidade
            ) {
              setValue("nomeMunicipio", response.localidade);
            }
            if (
              (!current.codigoMunicipio ||
                current.codigoMunicipio.toString().trim() === "") &&
              response.ibge
            ) {
              setValue("codigoMunicipio", response.ibge.toString());
            }
            if ((!current.uf || current.uf.trim() === "") && response.uf) {
              setValue("uf", response.uf);
            }
          }
        })
        .catch((err) => {
          console.error("Erro ao buscar CEP:", err);
        });
    }
  };

  const onSubmit = async (data: EmpresaDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.cep = SoNumeros(data.cep);
    data.documento = SoNumeros(data.documento);
    if (incluir === true) {
      EmpresaIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/inicio");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            showToast({
              message: "Ocorreu erro ao incluir cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      EmpresaAtualizar(data).then((response) => {
        if (response.data.success) {
          navigate("/inicio");
        } else {
          MapearErrosServidorCampo(response.data.notifications, setError);
          showToast({
            message: "Ocorreu erro ao incluir cadastro",
            title: "Erro",
            variant: "Danger",
          });
        }
      });
    }
    setLoading(false);
  };

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  return {
    loading,
    register,
    handleSubmit,
    errors,
    onSubmit,
    setValue,
    buscarCep,
    menuItens,
    handleClickNavigate,
  };
};
export default EmpresaCode;
